module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrapper"
  }, [_c('sidebar'), _vm._v(" "), _c('div', {
    staticClass: "body-wrapper"
  }, [_c('Header'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('Footer')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animate__animated animate__fadeIn",
      "leave-active-class": "animate__animated animate__fadeOut"
    }
  }, [(this.$store.getters.modal.createServiceModal) ? _c('create-services-modal') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animate__animated animate__fadeIn",
      "leave-active-class": "animate__animated animate__fadeOut"
    }
  }, [(this.$store.getters.modal.editServiceModal) ? _c('edit-services-modal') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animate__animated animate__fadeIn",
      "leave-active-class": "animate__animated animate__fadeOut"
    }
  }, [(this.$store.getters.modal.editClientModal) ? _c('edit-client-modal') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animate__animated animate__fadeIn",
      "leave-active-class": "animate__animated animate__fadeOut"
    }
  }, [(this.$store.getters.modal.groupOperationModal) ? _c('group-operation-modal') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animate__animated animate__fadeIn",
      "leave-active-class": "animate__animated animate__fadeOut"
    }
  }, [(this.$store.getters.modal.createBookingModal) ? _c('create-booking-modal') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animate__animated animate__fadeIn",
      "leave-active-class": "animate__animated animate__fadeOut"
    }
  }, [(this.$store.getters.modal.editBookingModal) ? _c('edit-booking-modal') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animate__animated animate__fadeIn",
      "leave-active-class": "animate__animated animate__fadeOut"
    }
  }, [(this.$store.getters.backDrop) ? _c('backdrop') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19a211e3","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layouts/Main.vue
// module id = xI8H
// module chunks = 17